import { CSSTransition } from "react-transition-group";
import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";

export interface ITextAndDotsDropdownProps {
    label?: string;
    cssWrapper: string;
    buttonTitle: string;
    onRef?: (ref) => void;
}

export interface ITextAndDotsDropdownState {
    isOpen: boolean;
}

export class TextAndDotsDropdown extends BaseComponent<ITextAndDotsDropdownProps, ITextAndDotsDropdownState> {
    constructor(props: ITextAndDotsDropdownProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }
    private wrapperRef;

    handleClickOutside = () => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {this.setState({ isOpen: false });}
    };

    ToggleDropdown = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    public componentDidMount() {
        if (this.props.onRef) {this.props.onRef(this);}
        document.addEventListener("touchstart", this.handleClickOutside);
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    public componentWillUnmount() {
        document.removeEventListener("touchstart", this.handleClickOutside);
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    private setWrapperRef = (el) => (this.wrapperRef = el);

    public render(): JSX.Element {
        const { cssWrapper, label, children, buttonTitle } = this.props;
        const { isOpen } = this.state;
        const CSSClasses = "text-and-dots-dropdown " + cssWrapper;

        return (
            <div className={CSSClasses} ref={this.setWrapperRef}>
                <button className="trigger" title={buttonTitle} onClick={() => this.ToggleDropdown()} aria-expanded={isOpen}>
                    <span className="text">{label}</span>
                    <span className="icon" aria-hidden={true} />
                </button>

                <CSSTransition in={isOpen} timeout={300} unmountOnExit classNames="dropear-csstrans">
                    <div className="dropear-list">
                        <span aria-hidden={true} className="dropear-list-sh1" />
                        <span aria-hidden={true} className="dropear-list-sh2" />
                        <div className="dropear-list-panel">
                            <div className="dropear-list-inner">{children}</div>
                        </div>
                    </div>
                </CSSTransition>
            </div>
        );
    }
}
